import { NgClass } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  forwardRef,
  input,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BaseFormControlComponent } from '../../../shared/components/base-form-control/base-form-control.component';
import { FormControlDirective } from '../../../shared/directives/form-control/form-control.directive';
import { FormOption } from '../../../shared/models/form-option.interface';

@Component({
  selector: 'app-form-radio',
  templateUrl: './radio.component.html',
  styleUrls: ['./radio.component.scss'],
  providers: [
    {
      provide: BaseFormControlComponent,
      useExisting: forwardRef(() => RadioComponent),
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormControlDirective, NgClass, ReactiveFormsModule],
  standalone: true,
})
export class RadioComponent extends BaseFormControlComponent<
  string | boolean | number
> {
  readonly options = input<FormOption<string | boolean | number>[] | null>(
    null,
  );
  readonly renderedOptions = computed(() =>
    this.isBinary() ? this.binaryOptions : (this.options() ?? []),
  );

  readonly nameInput = input<string | undefined>(undefined, {
    alias: 'name', // eslint-disable-line @angular-eslint/no-input-rename
  });

  inline = input<boolean>(true);
  isBinary = input<boolean>(false);
  size = input<'small' | 'large'>('small');

  private readonly binaryOptions: FormOption[] = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
  ];
}
